import { render, staticRenderFns } from "./MedecinDetailEvaluationcreate.vue?vue&type=template&id=1814b961&"
import script from "./MedecinDetailEvaluationcreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailEvaluationcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports